import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import Wave from '../images/Wave.svg';
import Create from '../images/Create.svg';
import PlusSign from '../images/plusSign.png';

import { useIconSwapService } from '../Components/IconSwapService.jsx';

export const CreateYourOwnSwapPanel = ({
  swapType,
  createSwap,
  login,
  responsiveLogin,
}: CreateYourOwnSwapPanelPropTypes) => {
  const history = useHistory();
  const { address } = useIconSwapService();

  useEffect(() => {
    getWindowDimensions();
  }, []);

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };
  const { innerWidth: width } = window;

  return (
    <CreateYourOwnSwapWrapper>
      <WaveImage src={Wave} alt={'wave'} />
      <CreateYourSwapImage src={Create} alt={'create your swap'} />
      <CreateSwapText>
        You can create a swap in order to trade your {swapType} for ICX, or vice
        versa... Trade your ICX to buy {swapType}.
      </CreateSwapText>
      <CreateSwapButton
        onClick={() => {
          if (!address && login) {
            return login();
          }

          if (!address && width < 415) {
            return responsiveLogin();
          }
          if (width < 415) {
            return history.push('/createSwap');
          }
          createSwap();
        }}
      >
        <PlusSignImage src={PlusSign} alt="plus sign"></PlusSignImage>
        <ButtonText>Create a swap</ButtonText>
      </CreateSwapButton>
    </CreateYourOwnSwapWrapper>
  );
};

export default CreateYourOwnSwapPanel;

const CreateYourOwnSwapWrapper = styled.div`
  width: 508px;
  min-width: 508px;
  height: 508px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 414px) {
    width: 335px;
    min-width: 335px;
    height: 468px;
  }
`;

const WaveImage = styled.img`
  width: 61px;
  height: 22px;
  margin-top: 80px;
  @media (max-width: 414px) {
    margin-top: 60px;
  }
`;

const CreateYourSwapImage = styled.img`
  height: 118px;
  width: 261px;
  margin-top: 32px;
`;

const CreateSwapText = styled.span`
  width: 358px;
  color: #0e0d0e;
  font-family: 'Avenir Next';
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  margin-top: 39px;
  line-height: 38px;
  @media (max-width: 414px) {
    margin-top: 18px;
  }
`;

const CreateSwapButton = styled.button`
  :focus {
    outline: none;
  }
  border: none;
  background-color: #007d81;
  height: 50px;
  width: 190px;
  border-radius: 4px;
  margin-top: 20px;
  @media (max-width: 414px) {
    margin-top: 30px;
    margin-bottom: 0;
  }
`;

const PlusSignImage = styled.img`
  height: 20px;
  width: 20px;
  object-fit: contain;
  margin-right: 10px;
`;

const ButtonText = styled.span`
  font-size: 16px;
  color: #fff;
`;

type CreateYourOwnSwapPanelPropTypes = {
  swapType: string;
  createSwap: () => void;
  login?: () => void;
  responsiveLogin: () => void;
};
